const COOKIE_NAME = "smww_attribution";

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
// Also capture attribution parameters after the URL hash
const hash = window.location.hash;

if (hash.includes("?")) {
  const hashParams = new URLSearchParams(
    hash.substring(hash.indexOf("?") + 1)
  );

  hashParams.forEach((value, key) => {
    params.set(key, value);
  });
}
  const visit = {
    landing_url: window.location.origin +
             window.location.pathname +
             window.location.search+
  window.location.hash,
    landing_path: window.location.pathname,
    referrer: document.referrer || "",
    captured_at: new Date().toISOString(),
     ga_client_id: getGAClientId(),
    payload: {},
  };

  params.forEach((value, key) => {
    visit.payload[key] = value;

    if (key.startsWith("utm_")) {
      visit[key] = value;
    }

    if (
      ["gclid", "gbraid", "wbraid", "gad_source", "fbclid", "li_fat_id"].includes(key)
    ) {
      visit[key] = value;
    }
  });
  //Only capture marketing attribution visits
  const hasAttribution =
    Object.keys(visit).some(key => key.startsWith("utm_")) ||
    visit.gclid ||
    visit.gbraid ||
    visit.wbraid ||
    visit.fbclid ||
    visit.li_fat_id ||
    visit.gad_source;

  if (!hasAttribution) {
    return;
  }

// Derive channel
if (visit.utm_medium) {
  const medium = visit.utm_medium.toLowerCase();

  if (medium === "cpc" || medium === "ppc" || medium.startsWith("paid")) {
    visit.channel = "paid";
  } else if (medium === "email") {
    visit.channel = "email";
  } else if (medium === "social" || medium === "paidsocial") {
    visit.channel = "social";
  } else {
    visit.channel = medium;
  }
} else if (visit.gclid || visit.fbclid || visit.li_fat_id) {
  visit.channel = "paid";
} else if (visit.referrer) {
  visit.channel = "referral";
} else {
  visit.channel = "direct";
}
  // Don't create cookie if nothing useful is present
  if (Object.keys(visit.payload).length === 0) {
    return;
  }

  let attribution = getCookie(COOKIE_NAME);

  if (!attribution) {
    attribution = {
      anonymous_id: crypto.randomUUID(),
      visits: [],
    };
  }

  const lastVisit =
  attribution.visits.length > 0
    ? attribution.visits[attribution.visits.length - 1]
    : null;

if (isDuplicateVisit(lastVisit, visit)) {
    attribution.visits[attribution.visits.length - 1] = {
        ...lastVisit,
        ...visit
    };
} else {
    attribution.visits.push(visit);
}

  document.cookie =
    COOKIE_NAME +
    "=" +
    encodeURIComponent(JSON.stringify(attribution)) +
     ";domain=.sportsmanagementworldwide.com" +
    ";path=/;max-age=" +
    90 * 24 * 60 * 60 +
    ";SameSite=Lax";
}
export function getAttributionCookie() {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");

    if (key === "smww_attribution") {
      console.log("Cookie value:", value);
      console.log("Decoded:", decodeURIComponent(value));

      return JSON.parse(decodeURIComponent(value));
    }
  }

  return null;
}
export function clearAttributionCookie() {
  document.cookie =
    "smww_attribution=; Path=/; Domain=.sportsmanagementworldwide.com; Max-Age=0; SameSite=Lax";
}
function getCookie(name) {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");

    if (key === name) {
      return JSON.parse(decodeURIComponent(value));
    }
  }

  return null;
}
function isDuplicateVisit(lastVisit, newVisit) {
  if (!lastVisit) {
    return false;
  }

  const clickIds = [
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "li_fat_id"
  ];

  // Same click ID = same visit
  for (const key of clickIds) {
    if (
      lastVisit[key] &&
      newVisit[key] &&
      lastVisit[key] === newVisit[key]
    ) {
      return true;
    }
  }

  // Same UTM visit = duplicate
  return (
    lastVisit.utm_source === newVisit.utm_source &&
    lastVisit.utm_medium === newVisit.utm_medium &&
    lastVisit.utm_campaign === newVisit.utm_campaign &&
    lastVisit.utm_content === newVisit.utm_content &&
    lastVisit.utm_term === newVisit.utm_term &&
    lastVisit.landing_path === newVisit.landing_path
  );
}
function getGAClientId() {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith("_ga=")) {
      const value = cookie.substring(4); // remove "_ga="

      // Example:
      // GA1.1.1365992503.1684221304
      return value.replace(/^GA\d+\.\d+\./, "");
    }
  }

  return "";
}
// SMWW-GA4ATTR: the buyer's GA4 client and session id for the stream the server sends the
// purchase to, read from Google's tag at checkout. Never blocks payment: waits for gtag, then
// resolves within 3 s with what it has, and always says why in capture_status (ok, no_gtag,
// timeout, no_client_id) and which build asked in bundle. No client id when the buyer refused
// analytics consent.
// The stream each site's page tag is configured with: live G-0B3L280149, every other host
// (PreTeam) the Dev stream G-F9REVGFPW7; the server's GA4_MEASUREMENT_ID matches per environment.
const GA4_MEASUREMENT_ID =
  window.location.hostname === "team.sportsmanagementworldwide.com" ? "G-0B3L280149" : "G-F9REVGFPW7";
const GA_CAPTURE_CAP_MS = 3000;
const GA_CAPTURE_VERSION = "r1";

// The served bundle's own file name (main.<hash>.js), so the server log shows which build asked.
function gaBundleName() {
  const script = document.querySelector('script[src*="/static/js/main."]');
  const name = script ? script.src.split("/").pop().split("?")[0] : "";
  return name ? GA_CAPTURE_VERSION + ":" + name : GA_CAPTURE_VERSION;
}

// Google's library itself, not only the page's gtag: public/index.html defines gtag() inline
// before gtag.js loads, so with the library blocked gtag exists but never answers.
function gaLibraryLoaded() {
  return typeof window.gtag === "function" && !!window.google_tag_manager;
}

export function getGaIdentity() {
  return new Promise((resolve) => {
    const out = {
      measurement_id: GA4_MEASUREMENT_ID,
      captured_at: new Date().toISOString(),
      bundle: gaBundleName()
    };
    const started = Date.now();
    let asked = false;
    let clientIdAnswered = false;
    let pending = 2;
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      if (/^\d+\.\d+$/.test(out.ga_client_id || "")) {
        out.capture_status = "ok";
      } else if (clientIdAnswered) {
        out.capture_status = "no_client_id";
      } else if (!asked || !gaLibraryLoaded()) {
        out.capture_status = "no_gtag";
      } else {
        out.capture_status = "timeout";
      }
      resolve(out);
    };
    const done = () => {
      pending -= 1;
      if (pending === 0) finish();
    };
    const ask = () => {
      asked = true;
      try {
        window.gtag("get", GA4_MEASUREMENT_ID, "client_id", (v) => { out.ga_client_id = v ? String(v) : ""; clientIdAnswered = true; done(); });
        window.gtag("get", GA4_MEASUREMENT_ID, "session_id", (v) => { out.ga_session_id = v ? String(v) : ""; done(); });
      } catch (e) {
        finish();
      }
    };
    // gtag can appear after the page: look for it every 100 ms until the cap, then ask once
    const poll = () => {
      if (finished) return;
      if (typeof window.gtag === "function") {
        ask();
      } else if (Date.now() - started < GA_CAPTURE_CAP_MS) {
        setTimeout(poll, 100);
      }
    };
    poll();
    setTimeout(finish, GA_CAPTURE_CAP_MS);
  });
}
